import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useParams } from 'react-router-dom';

import { atende, useAcesso } from '../../contexts/AcessoContext';
import TelaBloqueio from './TelaBloqueio';

/**
 * Uma rota que exige permissão (spec 20261019-gestao-de-acessos, RF10). `exige` é a lista de
 * exigências — `'tela'` ou `['tela', 'nivel']`, basta uma — ou uma função dos parâmetros da rota
 * que a devolve. Sem permissão, "Você não tem acesso a esta tela" no lugar da página.
 */
export const RotaProtegida = ({ exige, children }) => {
    const params = useParams();
    const { pode } = useAcesso();
    const exigencias = typeof exige === 'function' ? exige(params) : exige;
    if (!atende(pode, exigencias)) return <TelaBloqueio tipo="sem_acesso" />;
    return children;
};

RotaProtegida.propTypes = {
    exige: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
    children: PropTypes.node,
};

/** Exigência de cada página, para a rota e para o menu. */
export const EXIGE = {
    simulador: ['simulador.decisao', 'simulador.outros'],
    simuladorPasso: ({ passo }) => [passo === 'decisao' ? 'simulador.decisao' : 'simulador.outros'],
    analises: ['analises'],
    analisesAba: ({ aba }) => [aba === 'conferencia' ? 'analises.conferencia' : 'analises'],
    mercado: ['mercado'],
    metodologia: ['metodologia'],
    acessos: [['acessos', 'editar'], 'auditoria'],
    acessosAba: ({ aba }) => (aba === 'auditoria' ? [['acessos', 'editar'], 'auditoria'] : [['acessos', 'editar']]),
    fluxoCaixa: ['fluxo_caixa'],
    orcamento: ['orcamento'],
};

const DESTINOS = [
    ['/simulador/decisao', ['simulador.decisao']],
    ['/simulador/crescimento', ['simulador.outros']],
    ['/analises/liquidez', EXIGE.analises],
    ['/mercado', EXIGE.mercado],
    ['/metodologia', EXIGE.metodologia],
    ['/acessos/usuarios', [['acessos', 'editar']]],
    ['/acessos/auditoria', ['auditoria']],
];

/** Para onde vai quem abre `/`: a primeira página que a pessoa pode ver (o Simulador, em geral). */
export const destinoInicial = (pode) => (DESTINOS.find(([, exige]) => atende(pode, exige)) || DESTINOS[0])[0];

export const Inicio = () => {
    const { pode } = useAcesso();
    return <Navigate to={destinoInicial(pode)} replace />;
};

/** `/simulador` e `/acessos` sem passo/aba: o primeiro que a pessoa pode ver. */
export const InicioDe = ({ opcoes }) => {
    const { pode } = useAcesso();
    const destino = opcoes.find(([, exige]) => atende(pode, exige)) || opcoes[0];
    return <Navigate to={destino[0]} replace />;
};

InicioDe.propTypes = { opcoes: PropTypes.array.isRequired };

export const INICIO_SIMULADOR = [['/simulador/decisao', ['simulador.decisao']], ['/simulador/crescimento', ['simulador.outros']]];
export const INICIO_ACESSOS = [['/acessos/usuarios', [['acessos', 'editar']]], ['/acessos/auditoria', ['auditoria']]];
